import React from 'react'
import './CourseFeaturesBox.css'
import image1 from '../../Assets/images/features/2.png'
import image2 from '../../Assets/images/features/3.png'
import image3 from '../../Assets/images/features/4.png'
import image4 from '../../Assets/images/features/5.png'
import {PiBagSimpleBold} from 'react-icons/pi'
import {HiOutlineVideoCamera} from 'react-icons/hi'
import {MdOutlineLanguage} from 'react-icons/md'
import {BiTimer} from 'react-icons/bi'
export default function CourseFeaturesBox({courseData}) {
  return (
    <div className='course-features-box'>
        <div className='course-features-title'>
            <h3>برخی از ویژگی های کلیدی دوره</h3>
        </div>
        <div className='course-features-images'>
            <img src={image1} alt="ویژگی های دوره" />
            <img src={image2} alt="ویژگی های دوره" />
            <img src={image3} alt="ویژگی های دوره" />
            <img src={image4} alt="ویژگی های دوره" />
        </div>
        <ul>
            <li>
                <PiBagSimpleBold />
                سطح دوره : {courseData.courseLevel === 0 ? 'مبتدی' : courseData.courseLevel === 1 ? 'متوسط' : courseData.courseLevel === 2 ? 'پیشرفته' : ''}
            </li>
            <li>
                <HiOutlineVideoCamera />
                نوع دوره : آنلاین
            </li>
            <li>
                <MdOutlineLanguage />
                زبان دوره : {courseData.language}
            </li>
            <li>
                <BiTimer />
                پیشنیاز های دوره : {courseData.prerequisite==null?"ندارد":courseData.prerequisite}
            </li>
        </ul>
    </div>
  )
}
